import axios from "axios";
import client from "./ApiService";
class AiService {
  constructor() {
    this.url = "/posts";
  }

  getAiScoreByID(id){
    if(!id) return;
    return client.get(`${this.url}/ai-score/get?increment_id=${id}`);
  }
}

export default new AiService();
